document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('libraryMainsite-t-float_right');
  if (section) {
    const btnToggle = section.querySelector('.btn-toggle');
    if (btnToggle) {
      btnToggle.addEventListener('click', function (e) {
        e.preventDefault();
        section.classList.toggle('active');
        btnToggle.classList.toggle('active');
      });
    }
  }
});
